import { memo } from "react";
import { CurvedIcon, QuadraticIcon, StraightIcon } from "@/icons/line-types";
import { DashedLineIcon, DottedLineIcon, SolidLineIcon } from "@/icons/widget-menu";
import { HStack, VStack } from "@/shared/ui/Stack";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import type { DashType, LineOption, LineType } from "../../types";
import { LineTypeButton } from "./LineTypeButton";
import { LineWidthInput } from "./LineWidthInput";

interface LineTypeMenuContentProps {
    options: widgetOption<LineOption>[];
    lineWidth: number;
    selectedLineType: LineType;
    selectedDashType: DashType;
    onLineTypeButtonClick: (lineType: LineType) => void;
    onDashTypeButtonClick: (dashType: DashType) => void;
}

export const LineTypeMenuContent = memo(function LineTypeMenuContent({
    options,
    lineWidth,
    selectedLineType,
    selectedDashType,
    onLineTypeButtonClick,
    onDashTypeButtonClick,
}: LineTypeMenuContentProps) {
    return (
        <VStack gap={20}>
            <LineWidthInput initialWidth={lineWidth} options={options} />

            <HStack gap={4} fullWidth>
                <LineTypeButton
                    value={"straight"}
                    selectedValue={selectedLineType}
                    onClick={onLineTypeButtonClick}
                    Icon={StraightIcon}
                />

                <LineTypeButton
                    value={"quadratic"}
                    selectedValue={selectedLineType}
                    onClick={onLineTypeButtonClick}
                    Icon={QuadraticIcon}
                />

                <LineTypeButton
                    value={"curved"}
                    selectedValue={selectedLineType}
                    onClick={onLineTypeButtonClick}
                    Icon={CurvedIcon}
                />
            </HStack>

            <HStack gap={4} fullWidth>
                <LineTypeButton
                    value={"solid"}
                    selectedValue={selectedDashType}
                    onClick={onDashTypeButtonClick}
                    Icon={SolidLineIcon}
                />

                <LineTypeButton
                    value={"dashed"}
                    selectedValue={selectedDashType}
                    onClick={onDashTypeButtonClick}
                    Icon={DashedLineIcon}
                />

                <LineTypeButton
                    value={"dotted"}
                    selectedValue={selectedDashType}
                    onClick={onDashTypeButtonClick}
                    Icon={DottedLineIcon}
                />
            </HStack>
        </VStack>
    );
});
